import {
  ApiResponse,
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  getToken,
} from "@/scripts/Common";

import {
  Card,
  ProfipayCardStates,
  SearchFilterParameters,
} from "@/components/cards/scripts/types";

import {
  DataTableOptions
} from "@/composables";

import {
  Ref
} from "vue";

const checkCard = async (cardNumber: number): Promise<ApiResponse<ProfipayCardStates[]>> =>
  await defaultFetch({
    apiName: 'getProfipayCardStates',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
      query: {
        cardNumbers: [cardNumber]
      }
    }
  });

const fetchCards = async (options: Ref<DataTableOptions>, queryParams: SearchFilterParameters) => {
  options.value.loading = true;

  const {
    error,
    paginationCount,
    totalItemCount,
    response,
  } = await defaultFetch({
    apiName: 'getCardList',
    bearer: getToken(),
    options: {
      query: {
        pageNumber: (options.value.pagination.page - 1),
        pageSize: options.value.pagination.itemsPerPage,
        cardNumber: queryParams.cardNumber,
        state: queryParams.cardState,
        sortColumn: options.value.sorting.sortBy,
        sortDirection: options.value.sorting.sortDesc ? 'desc' : 'asc',
      }
    }
  });

  options.value.loading = false;

  options.value.pagination.pageCount = paginationCount ?? 0;
  options.value.pagination.totalItemCount = totalItemCount ?? 0;

  return {
    response,
    paginationCount,
    totalItemCount,
    error
  }
};

const updateOrCreateCardList = async (method: httpMethod, cards: Card[]) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'updateOrCreateCards',
    bearer: getToken(),
    options: {
      method,
    },
    body: JSON.stringify({
      cardDtoList: cards
    }),
  });

  return{
    response,
    error
  }
}

const deleteCards = async (cardIds: number[]) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'deleteCards',
    bearer: getToken(),
    options: {
      method: httpMethod.POST
    },
    body: JSON.stringify({
      cardIdList: cardIds
    }),
  });

  return {
    response,
    error
  }
}

const loadCardStates = async (cardNumbers: number[], options: Ref<DataTableOptions>) => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'getProfipayCardStates',
    bearer: getToken(),
    options: {
      method: httpMethod.GET,
      query: {
        cardNumbers: cardNumbers,
        pageNumber: (options.value.pagination.page - 1),
        pageSize: options.value.pagination.itemsPerPage,
      }
    }
  });

  return {
    response,
    error
  }
}


export {
  checkCard,
  fetchCards,
  updateOrCreateCardList,
  deleteCards,
  loadCardStates
}
